import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {Checkbox} from "@irati/ui/src/FormItem"
import {CheckboxOutline} from "@irati/ui/src/FormItem/Checkbox/styled"

interface StyledProps {
  isExternalPage?: boolean
}

export const ResponsiveFlex = styled(Flex)<StyledProps>`
  ${({isExternalPage, theme}) => css`
    flex: 0 0 60%;

    ${theme.mediaQueries.minWidthMedia.tablet`
      flex: 0 0 ${isExternalPage ? "75%" : "65%"};
    `}
  `}
`

export const Label = styled.label`
  margin: 0;
  user-select: none;

  &:active,
  &:hover {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }
`

export const EmailCheckbox = styled(Checkbox).attrs({
  tabIndex: 0
})<StyledProps>`
  ${CheckboxOutline} {
    &:active,
    &:hover {
      outline: none;
    }
  }

  position: relative;
  right: ${({isExternalPage}) => (isExternalPage ? "-4px" : "14px")};

  ${({isExternalPage, theme}) => theme.mediaQueries.minWidthMedia.tablet`
    right: ${isExternalPage ? "-8px" : "14px"};
  `}
`
